import { Configuration, PopupRequest, RedirectRequest } from "@azure/msal-browser";

export const b2cPolicies = {
  names: {
      signUpSignIn: "b2c_1_susi_reset_v2",
      editProfile: "b2c_1_edit_profile_v2"
  },
  authorities: {
      signUpSignIn: {
          authority: "https://HyperGES.b2clogin.com/HyperGES.onmicrosoft.com/b2c_1_susi",
      },
      editProfile: {
          authority: "https://HyperGES.b2clogin.com/HyperGES.onmicrosoft.com/b2c_1_edit_profile"
      }
  },
  authorityDomain: "HyperGES.b2clogin.com",
  cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true
  }
};


export const msalConfig: Configuration = {
  auth: {
      clientId: '29a63b0f-a3cc-4c2c-901d-b6df9a70a385',
      authority: b2cPolicies.authorities.signUpSignIn.authority,
      knownAuthorities: [b2cPolicies.authorityDomain],
      redirectUri: '/', 
  },
 // More configuration here
}

export const loginRequest = {
  scopes: [
    "https://hyper-ges.it/api/access_as_user"
  ]
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};